module.exports = __webpack_public_path__ + "static/media/16b-04_Ncrekonchoe-4-2016-128x95cm-oleo-y-aceite-de-lino-sobre-papel.6b715ac2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16b/16b-04_Ncrekonchoe-4-2016-128x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 191
// module chunks = 0